// extracted by mini-css-extract-plugin
export default {"closeButton":"MenuMobile_closeButton__rluqK","container":"MenuMobile_container__DKEY3","firstRow":"MenuMobile_firstRow__56rQD","textButtons":"MenuMobile_textButtons__TGLIp"};